module.exports = __webpack_public_path__ + "img/img.99c58666.png";